import AccessControlLayout, { AdminTest, UserTest, PublicTest } from '../layouts/AccessControlLayout';
import ErrorPage from '../pages/ErrorPage';
// import Base from '../layouts/Base';

const AuthTestRoutes = {
    path:'authtest',
    errorElement: <ErrorPage/>,
    children:[
        // Admin users only: <AccessControlLayout isAdmin = {true} />
        {
            element: <AccessControlLayout isAdmin={true} useBaseLayout={true}/>,
            children:[
                {
                    path:'admin',
                    element:<AdminTest></AdminTest>
                }
            ]
                
        },
        // Public users allowed: <AccessControlLayout isPublic = {true} />
        {
            element: <AccessControlLayout isPublic={true} useBaseLayout={true}/>,
            children:[
                {
                    path:'public',
                    element:<PublicTest></PublicTest>
                },
            ]
        },
        // Logged in users only: <AccessControlLayout /> without further specifiers
        {
            element: <AccessControlLayout useBaseLayout={true}/>,
            children:[
                {
                    path:'user',
                    element:<UserTest></UserTest>
                },
            ]
        },
    ]
}

export default AuthTestRoutes;